import React from 'react'
import _ from 'lodash'

class FullHeightCalculator extends React.PureComponent {

  constructor(props) {
    super(props);
  }

  onResize() {
    this.resizeContainer();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
  }

  resizeContainer() {

    const { heightAdjust = 0 } = this.props;

    if (!this.refs.content) return;

    let contentContainer = this.refs.content;
    let offsetTop = this.refs.content.offsetTop;
    let windowHeight = window.innerHeight;

    contentContainer.style.height = (windowHeight - offsetTop + heightAdjust) + "px";
  }

  componentDidMount() {
    this.resizeContainer();
    this.onResize = _.debounce(this.onResize.bind(this), 300);
    window.addEventListener("resize", this.onResize, false);
  }

  render() {

    this.resizeContainer();

    return (
      <div className={"full-height-calculator"} ref="content">
        <div className="full-height-container">
          {this.props.children}
        </div>
      </div>
    )
  }

}


export default FullHeightCalculator;



// WEBPACK FOOTER //
// ./src/components/FullHeightCalculator.js